import { confirmPlus } from "../common/custom_confirm";

export class BookNowQuestionnaire extends HTMLElement {
  constructor(goBack) {
    super();
    this.goBack = goBack;
  }

  async connectedCallback() {
    this.domain_id = document.querySelector("#object_id").value;

    let res = await fetch(`/admin/domains/${this.domain_id}/book_now/services`, 
        {headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
        method: 'GET'
      });

    let json = await res.json();

    this.innerHTML = 
      `
        <div class="row">
          <div class="col-sm-9">
            <h3 class="pull-left"><span id="book-now-back" class="back-chevron"></span> Booking Services</h3>
            <button class="btn btn-primary btn-outline-primary pull-right" id="book-now-add-business-unit">Add Service</button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-9 no-gutters" id="book-now-business-unit-container">
          </div>
        </div>
        <div class="row">
          <div class="col-sm-9 no-gutters">
            <button class="btn btn-primary" id="book-now-save-services">Save</button>
          </div>
        </div>
      `;

      json.forEach((business_unit) => {
        this.querySelector("#book-now-business-unit-container").appendChild(new BookNowBusinessUnit(business_unit))
      });

      this.querySelector("#book-now-add-business-unit").addEventListener("click", function(e) {
        e.preventDefault();
        let new_ordinal = this.querySelectorAll('book-now-business-unit').length + 1;
        this.querySelector("#book-now-business-unit-container").appendChild(new BookNowBusinessUnit(null, new_ordinal))
      }.bind(this));

      this.querySelector("#book-now-back").addEventListener("click", function() {
        this.goBack();
      }.bind(this));

      this.querySelector("#book-now-save-services").addEventListener("click", function(e) {
        e.preventDefault();
        this.save();
      }.bind(this));
  }

  async save() {
    if(this.validate()) {
      let data = [];
      this.querySelectorAll("book-now-business-unit").forEach((business_unit) => {
        data.push(business_unit.getData());
      });

      console.log(data);

      let res = await fetch(`/admin/domains/${this.domain_id}/book_now/services`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(data)
      })

      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();
      if(response.success) {
        this.connectedCallback();
        Common.notify('Book Now Services saved.', 'success');
      } else {
        Common.notify(`Unable to save Book Now services. ${response.error ? response.error : ""}`, 'error');
      }
    }
  }

  validate() {
    let all_valid = true;
    this.querySelectorAll("book-now-business-unit").forEach((business_unit) => {
      if(!business_unit.validate()) {
        all_valid = false;
      }
    });

    if(!all_valid) {
      Common.notify("Please fill out all required fields","danger")
    }
    
    return all_valid;
  }
}

customElements.define('book-now-questionnaire', BookNowQuestionnaire)

class BookNowBusinessUnit extends HTMLElement {
  constructor(business_unit, ordinal=1) {
    super();

    this.domain_id = document.querySelector("#object_id").value;

    const INITIAL_MESSAGE_TIME = 0;
    const CONFIRMATION_MESSAGE_TIME = 2;

    this.deleted = false;
    this.business_unit = business_unit;
    if(this.business_unit) {
      let business_unit_initial_messages = business_unit.business_unit_messages.filter((message) => {return message.timing == INITIAL_MESSAGE_TIME})
      let business_unit_confirmation_messages = business_unit.business_unit_messages.filter((message) => {return message.timing == CONFIRMATION_MESSAGE_TIME})
      this.business_unit_initial_message = business_unit_initial_messages.length > 0 ? business_unit_initial_messages[0] : null
      this.business_unit_confirmation_message = business_unit_confirmation_messages.length > 0 ? business_unit_confirmation_messages[0] : null
    }
  }

  connectedCallback() {
    this.innerHTML = `
      <style> 
        book-now-business-unit .btn {
          margin-left: 10px;
        }

        .book-now-up, .book-now-down {
          cursor: pointer;
        }

        .book-now-up:hover, .book-now-down:hover {
          color: lightgray;
        }

        book-now-business-unit:first-child > div > .row > div > h4 .book-now-arrows > .book-now-up,
        book-now-business-unit:last-child > div > .row > div > h4 .book-now-arrows > .book-now-down,
        book-now-category:first-child > .row > div >h4 .book-now-up,
        book-now-category:last-child > .row > div > h4 .book-now-down,
        book-now-job-type:first-child > .row > div > h4 .book-now-up,
        book-now-job-type:last-child > .row > div > h4 .book-now-down,
        book-now-question:first-child > div > .row > div > h4 .book-now-up,
        book-now-question:last-child > div > .row > div > h4 .book-now-down {
          display: none;
        }

        #book-now-business-unit-container,
        #book-now-category-container,
        #book-now-job-type-container,
        #book-now-questions-container {
          counter-reset: item-number;
        }

        .book-now-ordinal {
          counter-increment: item-number;
        }
        
        .book-now-ordinal::before {
          content: counter(item-number);
        }
      </style>
      <div class="panel panel-default" style="background-color: #F5F5F5;padding: 10px 0px;margin-top:10px;">
        <div class="row">
          <div class="col-sm-12"> 
            <h4 class="pull-left">Service <span class="book-now-ordinal"><span class="book-now-arrows"><span class="fa-solid fa-chevron-up book-now-up"></span><span class="fa-solid fa-chevron-down book-now-down"></span></span></span></h4>
            <button class="btn btn-outline-primary pull-right" id="book-now-add-category">Add Category</button>
            <button class="btn btn-danger pull-right" id="book-now-remove-business-unit">Remove Service</button>
          </div>
          <div class="errors-container col-sm-12"></div>
          <div class="col-sm-6">
            <div>
              <label>Service Name</label>
            </div>
            <input class="form-control business-unit-name" type="text" placeholder="Repair, Maintenance, Quote" value="${this.business_unit ? this.business_unit.alias : ""}"/>
          </div>
          <div class="col-sm-6">
            <div>
              <label>CRM Business Unit</label>
            </div>
            <select class="form-control" is="book-now-business-units-select" domain_id="${this.domain_id}" data-selected="${this.business_unit ? this.business_unit.external_unit_id : ""}"></select>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div>
              <label>Initial Message</label>
            </div>
            <textarea class="form-control initial-message" placeholder="If you need an Emergency Service immediatly please call us between 9:00am and 5:00pm.">${this.business_unit_initial_message != null ? this.business_unit_initial_message.message : ""}</textarea>
          </div>
          <div class="col-sm-6">
            <div>
              <label>Confirmation Message</label>
            </div>
            <textarea class="form-control confirmation-message" placeholder="Repair come with a minimum service charge of $99.">${this.business_unit_confirmation_message != null ? this.business_unit_confirmation_message.message : ""}</textarea>
          </div>
        </div>
      </div>
      <div class="col-sm-12" id="book-now-category-container">
        
      </div>
    `

    this.querySelector("#book-now-add-category").addEventListener("click", function(e) {
      e.preventDefault();
      let new_ordinal = this.querySelectorAll('book-now-category').length + 1;
      this.querySelector("#book-now-category-container").appendChild(new BookNowCategory(null, new_ordinal, this.querySelector("select").value == "null" ? null : this.querySelector("select").value))
    }.bind(this));

    this.querySelector('#book-now-remove-business-unit').addEventListener('click', async (e) => {
      e.preventDefault();
      if (this.business_unit) {
        const confirmed = await confirmPlus(
          `Are you sure you want to remove service "${this.business_unit.alias}"?`
        );
        if (confirmed) {
          this.deleted = true;
          this.classList.add('hidden');
        }
      } else {
        const confirmed = await confirmPlus('Are you sure you want to remove this service?');
        if (confirmed) {
          this.remove();
        }
      }
    });

    let category_container = this.querySelector("#book-now-category-container")
    if(this.business_unit) {
      this.business_unit.business_unit_categories.forEach((category) => {
        category_container.appendChild(new BookNowCategory(category, null, this.business_unit.external_unit_id));
      })
    } else {
      category_container.appendChild(new BookNowCategory())
    }

    this.querySelector('.book-now-up').addEventListener('click', function() {
      this.moveUp()
    }.bind(this))

    this.querySelector('.book-now-down').addEventListener('click', function() {
      this.moveDown()
    }.bind(this))


    this.querySelector('select').addEventListener('change', (e) => {
      this.querySelectorAll('book-now-category').forEach((category) => {
        console.log(e)
        category.setBusinessUnit(e.target.value)
      });
    });
  }

  getData() {
    const INITIAL_MESSAGE_TIME = 0;
    const CONFIRMATION_MESSAGE_TIME = 2;
    let categories = [];
    this.querySelectorAll("book-now-category").forEach((book_now_category) => {
      categories.push(book_now_category.getData());
    });

    let messages = [];
    let initial_message = this.querySelector(".initial-message").value.trim();
    let confirmation_message = this.querySelector(".confirmation-message").value.trim();

    if(initial_message.length > 0) {
      messages.push({
        business_unit_message_id: this.business_unit_initial_message ? this.business_unit_initial_message.business_unit_message_id : null,
        ordinal: 0,
        timing: INITIAL_MESSAGE_TIME,
        message: initial_message,
      });
    } else if(this.business_unit_initial_message){
      messages.push({
        business_unit_message_id: this.business_unit_initial_message.business_unit_message_id,
        _delete: true
      });
    }

    if(confirmation_message.length > 0) {
      messages.push({
        business_unit_message_id: this.business_unit_confirmation_message ? this.business_unit_confirmation_message.business_unit_message_id : null,
        ordinal: 0,
        timing: CONFIRMATION_MESSAGE_TIME,
        message: confirmation_message,
      });
    } else if(this.business_unit_confirmation_message){
      messages.push({
        business_unit_message_id: this.business_unit_confirmation_message.business_unit_message_id,
        _delete: true
      });
    }

    let data = {
      business_unit_id: this.business_unit ? this.business_unit.business_unit_id : null,
      alias: this.querySelector(".business-unit-name").value.trim(),
      external_unit_id: this.querySelector("select").value,
      external_unit_name: this.querySelector("select").options[this.querySelector("select").selectedIndex].text,
      _delete: this.deleted,
      business_unit_categories: categories,
      business_unit_messages: messages
    }

    return data;
  }

  validate() {
    let all_valid = true;

    let errors = "";

    if(this.querySelector(".business-unit-name").value.trim().length <= 0) {
      all_valid = false;
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> Please provide a Business Unit name.
                    </div>`;
    }

    if(this.querySelector("select").value == "null") {
      all_valid = false;
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> Please provide a CRM Business Unit.
                    </div>`;
    }

    this.querySelector('.errors-container').innerHTML = errors;

    this.querySelectorAll("book-now-category").forEach((book_now_category) => {
      if(!book_now_category.validate()) {
        all_valid = false;
      }
    });
    return all_valid;
  }

  async moveUp() {
    if(!await confirmPlus(`Are you sure you want to change the order of this business unit?`)) {
      return
    } 
    let temp_data = {
      name: this.querySelector('.business-unit-name').value,
      business_unit:this.querySelector('select').value,
      initial_message: this.querySelector('.initial-message').value,
      confirmation_message: this.querySelector('.confirmation-message').value
    }

    this.previousElementSibling.before(this);

    this.querySelector('.business-unit-name').value = temp_data.name;
    this.querySelector('select').value = temp_data.business_unit;
    this.querySelector('.initial-message').value = temp_data.initial_message;
    this.querySelector('.confirmation-message').value = temp_data.confirmation_message;
  }

  async moveDown() {
    if(!await confirmPlus(`Are you sure you want to change the order of this business unit?`)) {
      return
    }
    let temp_data = {
      name: this.querySelector('.business-unit-name').value,
      business_unit:this.querySelector('select').value,
      initial_message: this.querySelector('.initial-message').value,
      confirmation_message: this.querySelector('.confirmation-message').value
    }

    this.nextElementSibling.after(this);

    this.querySelector('.business-unit-name').value = temp_data.name;
    this.querySelector('select').value = temp_data.business_unit;
    this.querySelector('.initial-message').value = temp_data.initial_message;
    this.querySelector('.confirmation-message').value = temp_data.confirmation_message;
  }
}

customElements.define('book-now-business-unit', BookNowBusinessUnit)

class BookNowCategory extends HTMLElement {
  constructor(category, ordinal=1, business_unit) {
    super();
    this.deleted
    this.category = category;
    this.business_unit = business_unit;
  }

  connectedCallback() {
    this.innerHTML = `
        <style>
          book-now-category {
            margin-left: 40px;
            display: block;
            margin-bottom: 10px;
          }
        </style>
        <div class="row">
          <div class="col-sm-12 no-gutters"> 
            <h4 class="pull-left">Issue Category <span class="book-now-ordinal"> <span class="book-now-arrows"><span class="fa-solid fa-chevron-up book-now-up"></span><span class="fa-solid fa-chevron-down book-now-down"></span></span></h4>
            <button class="btn btn-outline-primary pull-right" id="book-now-add-job-type">Add Job Type</button>
            <button class="btn btn-danger pull-right" id="book-now-remove-category">Remove Issue</button>
          </div>
          <div class="errors-container col-sm-12"></div>
        </div>
        <div class="row">
          <div class="col-sm-12 no-gutters">
            <div>
              <label>Issue Category Name</label>
            </div>
            <input class="form-control job-type-category-name" type="text" placeholder="HVAC, Plumbing, Air Quality" value="${this.category ? this.category.alias : ""}"/>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 no-gutters" id="book-now-job-type-container">
            
          </div>
        </div>
    `
    this.querySelector("#book-now-add-job-type").addEventListener("click", function(e) {
      e.preventDefault();
      let new_ordinal = this.querySelectorAll('book-now-job-type').length + 1;
      this.querySelector("#book-now-job-type-container").appendChild(new BookNowJobType(null, new_ordinal, this.business_unit))
    }.bind(this));

    this.querySelector('#book-now-remove-category').addEventListener('click', async (e) => {
      e.preventDefault();
      if (this.category) {
        const confirmed = await confirmPlus(
          `Are you sure you want to remove issue category "${this.category.alias}"?`
        );
        if (confirmed) {
          this.deleted = true;
          this.classList.add('hidden');
        }
      } else {
        const confirmed = await confirmPlus('Are you sure you want to remove this issue category?');
        if (confirmed) {
          this.remove();
        }
      }
    });

    let job_type_container = this.querySelector("#book-now-job-type-container")
    if(this.category) {
      this.category.business_unit_category_job_types.forEach((job_type) => {
        job_type_container.appendChild(new BookNowJobType(job_type, null, this.business_unit));
      })
    } else {
      job_type_container.appendChild(new BookNowJobType(null, null, this.business_unit))
    }

    this.querySelector('.book-now-up').addEventListener('click', function() {
      this.moveUp()
    }.bind(this))

    this.querySelector('.book-now-down').addEventListener('click', function() {
      this.moveDown()
    }.bind(this))
  }

  setBusinessUnit(business_unit) {
    this.business_unit = business_unit;
    this.querySelectorAll("book-now-job-type").forEach((job_type) => {
      console.log(business_unit);
        job_type.setBusinessUnit(business_unit)
      });
  }

  getData() {
    let business_unit_category_job_types = [];
    this.querySelectorAll("book-now-job-type").forEach((book_now_job_type) => {
      business_unit_category_job_types.push(book_now_job_type.getData());
    });


    let data = {
      business_unit_category_id: this.category ? this.category.business_unit_category_id : null,
      alias: this.querySelector(".job-type-category-name").value.trim(),
      business_unit_category_job_types: business_unit_category_job_types,
      _delete: this.deleted
    }

    return data;
  }

  validate() {
    let all_valid = true;

    let errors = "";

    if(this.querySelector(".job-type-category-name").value.trim().length <= 0) {
      all_valid = false;
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> Please provide a Issue Category name.
                    </div>`;
    }

    this.querySelector('.errors-container').innerHTML = errors;

    this.querySelectorAll("book-now-job-type").forEach((book_now_job_type) => {
      if(!book_now_job_type.validate()) {
        all_valid = false;
      }
    });
    return all_valid;
  }

  async moveUp() {
    if(!await confirmPlus(`Are you sure you want to change the order of this category?`)) {
      return
    }
    let temp_data = {
      name: this.querySelector('.job-type-category-name').value
    }

    this.previousElementSibling.before(this);

    this.querySelector('.job-type-category-name').value = temp_data.name;
  }

  async moveDown() {
    if(!await confirmPlus(`Are you sure you want to change the order of this category?`)) {
      return
    }
    let temp_data = {
      name: this.querySelector('.job-type-category-name').value
    }

    this.nextElementSibling.after(this);

    this.querySelector('.job-type-category-name').value = temp_data.name;
  }
}

customElements.define('book-now-category', BookNowCategory)

class BookNowJobType extends HTMLElement {
  constructor(job_type, ordinal=1, business_unit_id) {
    super();
    this.deleted = false;
    this.job_type = job_type;
    this.domain_id = document.querySelector("#object_id").value;
    this.business_unit_id = business_unit_id;
  }

  connectedCallback() {
    this.innerHTML = `
        <style>
          book-now-job-type {
            margin-left: 40px;
            display: block;
            margin-top: 10px;
          }
        </style>
        <div class="row">
          <div class="col-sm-12 no-gutters"> 
            <h4 class="pull-left">Job <span class="book-now-ordinal"></span> <span class="book-now-arrows"><span class="fa-solid fa-chevron-up book-now-up"></span><span class="fa-solid fa-chevron-down book-now-down"></span></span></span></h4>
            <button class="btn btn-outline-primary pull-right" id="book-now-add-question">Add Question</button>
            <button class="btn btn-danger pull-right" id="book-now-remove-job-type">Remove Job</button>
          </div>
          <div class="errors-container col-sm-12"></div>
        </div>
        <div class="row">
          <div class="col-sm-6 no-gutters" style="padding-right: 10px !important;">
            <div>
              <label>Job Type Name</label>
            </div>
            <input class="form-control job-name" type="text" placeholder="No Heat, No Cool, Water Heater" value="${this.job_type ? this.job_type.alias : ""}"/>
          </div>
          <div class="col-sm-6 no-gutters">
            <div>
              <label>CRM Job Type</label>
            </div>
            <select class="form-control" is="book-now-job-types-select" domain_id="${this.domain_id}" business_unit_id="${this.business_unit_id}" data-selected="${this.job_type ? this.job_type.external_job_type_id : "null"}"></select>
          </div>
        </div>
        <div class="row" id="book-now-questions-container" style="margin: 10px 0px 0px 40px"> 
        </div>
    `

    this.querySelector("#book-now-add-question").addEventListener("click", function(e) {
      e.preventDefault();
      this.querySelector("#book-now-questions-container").appendChild(new BookNowQuestion(null))
    }.bind(this));

    this.querySelector('#book-now-remove-job-type').addEventListener('click', async (e) => {
      e.preventDefault();
      if (this.job_type) {
        const confirmed = await confirmPlus(
          `Are you sure you want to remove job type "${this.job_type.alias}"?`
        );
        if (confirmed) {
          this.deleted = true;
          this.classList.add('hidden');
        }
      } else {
        const confirmed = await confirmPlus('Are you sure you want to remove this job type?');
        if (confirmed) {
          this.remove();
        }
      }
    });

    let questions_container = this.querySelector("#book-now-questions-container")
    if(this.job_type) {
      this.job_type.job_type_questions.forEach((question, index) => {
        questions_container.appendChild(new BookNowQuestion(question));
      })
    }

    this.querySelector('.book-now-up').addEventListener('click', function() {
      this.moveUp()
    }.bind(this))

    this.querySelector('.book-now-down').addEventListener('click', function() {
      this.moveDown()
    }.bind(this))
  }

  setBusinessUnit(business_unit_id) {
    this.querySelector("select").setBusinessUnit(business_unit_id);
  }

  getData() {
    let job_type_questions = [];
    this.querySelectorAll("book-now-question").forEach((book_now_question) => {
      job_type_questions.push(book_now_question.getData());
    });


    let data = {
      job_type_id: this.job_type ? this.job_type.job_type_id : null,
      alias: this.querySelector(".job-name").value.trim(),
      external_job_type_id: this.querySelector("select").value,
      external_job_type_name: this.querySelector("select").options[this.querySelector("select").selectedIndex].text,
      job_length: this.querySelector("select").getJobLength(),
      job_type_questions: job_type_questions,
      _delete: this.deleted
    }

    return data;
  }

  validate() {
    let all_valid = true;
    let errors = "";

    if(this.querySelector(".job-name").value.trim().length <= 0) {
      all_valid = false;
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> Please provide a Job Name.
                    </div>`;
    }

    if(this.querySelector("select").value == "null") {
      all_valid = false;
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> CRM Job Type is required.
                    </div>`;
    }

    this.querySelector('.errors-container').innerHTML = errors;

    this.querySelectorAll("book-now-question").forEach((book_now_question) => {
      if(!book_now_question.validate()) {
        all_valid = false;
      }
    });
    return all_valid;
  }

  async moveUp() {
    if(!await confirmPlus(`Are you sure you want to change the order of this job type?`)) {
      return
    }
    let temp_data = {
      name: this.querySelector('.job-name').value,
      type:this.querySelector('select').value
    }

    this.previousElementSibling.before(this);

    this.querySelector('.job-name').value = temp_data.name;
    this.querySelector('select').value = temp_data.type;
  }

  async moveDown() {
    if(!await confirmPlus(`Are you sure you want to change the order of this job type?`)) {
      return
    }
    let temp_data = {
      name: this.querySelector('.job-name').value,
      type:this.querySelector('select').value
    }

    this.nextElementSibling.after(this);

    this.querySelector('.job-name').value = temp_data.name;
    this.querySelector('select').value = temp_data.type;
  }
}

customElements.define('book-now-job-type', BookNowJobType)

class BookNowQuestion extends HTMLElement {
  constructor(question) {
    super();
    this.deleted = false;
    this.question = question;
  }

  connectedCallback() {
    this.innerHTML = `
        <style>
          book-now-question {
            width: 50%;
            display: block;
            float: left;
            padding-left: 10px;
          }
        </style>
        <div class="panel panel-default" style="padding: 10px;">
          <div class="row">
            <div class="errors-container col-sm-12"></div>
            <div class="col-sm-12 no-gutters"> 
              <h4 class="pull-left">Question <span class="book-now-ordinal"></span> <span class="book-now-arrows"><span class="fa-solid fa-chevron-up book-now-up"></span><span class="fa-solid fa-chevron-down book-now-down"></span></span></h4>
              <button class="btn btn-danger pull-right" id="book-now-remove-question">Remove Question</button>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 no-gutters">
              <div>
                <label>Question</label>
              </div>
              <input class="form-control" type="text" id="book-now-question" placeholder="Please provide details of the issue you are having?" value="${this.question ? this.question.question_text : ""}"/>
              <div>
                <label>Type</label>
              </div>
              <select class="form-control" id="book-now-question-type">
                <option value="text" ${this.question && this.question.question_type=="text" ? "selected" : ""}>Text Response</option>
                <option value="yes_no" ${this.question && this.question.question_type=="yes_no" ? "selected" : ""}>Yes / No</option>
                <option value="select" ${this.question && this.question.question_type=="select" ? "selected" : ""}>Multi-choice</option>
              </select>
              <div>
                <label>Answer Input</label>
              </div>
              <textarea class="form-control" id="book-now-question-answers" placeholder="Seperate possibly answers with pipe '|'. e.g. Gas|Electric|Other" ${!this.question || this.question.question_type!="select" ? "disabled" : ""}>${this.question && this.question.question_type=="select" ? this.question.job_type_answers.map((answer) => {return answer.answer}).join("|") : ""}</textarea>
            </div>
          </div>
        </div>
    `

    this.querySelector('#book-now-remove-question').addEventListener('click', async (e) => {
      e.preventDefault();
      if (this.question) {
        const confirmed = await confirmPlus(
          `Are you sure you want to remove question "${this.question.question_text}"?`
        );
        if (confirmed) {
          this.deleted = true;
          this.classList.add('hidden');
        }
      } else {
        const confirmed = await confirmPlus('Are you sure you want to remove this question?');
        if (confirmed) {
          this.remove();
        }
      }
    });

    this.querySelector("#book-now-question-type").addEventListener("change", function(e) {
      if(e.target.value == "select") {
        this.querySelector("#book-now-question-answers").removeAttribute("disabled")
      } else {
        this.querySelector("#book-now-question-answers").setAttribute("disabled", true)
      }
    }.bind(this));

    this.querySelector('.book-now-up').addEventListener('click', function() {
      this.moveUp()
    }.bind(this))

    this.querySelector('.book-now-down').addEventListener('click', function() {
      this.moveDown()
    }.bind(this))
  }

  getData() {
    let job_type_answers = [];
    let deleted_answers = [];
    let new_answers = []
    this.querySelector("#book-now-question-answers").value.split("|").forEach((answer) => {
      new_answers.push(answer.trim());
    });
    if(this.question) {
      this.question.job_type_answers.forEach((answer) => {
        if(new_answers.indexOf(answer.answer) < 0) {
          answer._delete = true;
          deleted_answers.push(answer);
        }
      });
    }
    new_answers.forEach((answer, answer_ordinal) => {
      if(answer.trim().length == 0) {
        return;
      }
      let job_type_answer_id = null;
      if(this.question) {
        let located_answer = this.question.job_type_answers.find(existing_answer => existing_answer.answer == answer)
        job_type_answer_id = located_answer ? located_answer.job_type_answer_id : null;
      }
      job_type_answers.push({
        job_type_answer_id: job_type_answer_id,
        answer: answer.trim(),
        ordinal: answer_ordinal,
      });
    });

    let answers_data = job_type_answers.concat(deleted_answers);

    let question_type = this.querySelector("#book-now-question-type").value;

    let data = {
      job_type_question_id: this.question ? this.question.job_type_question_id : null,
      question_text: this.querySelector("#book-now-question").value.trim(),
      question_type: question_type,
      job_type_answers: answers_data,
      _delete: this.deleted
    }

    return data;
  }

  validate() {
    let all_valid = true;
    let errors = "";

    if(this.querySelector("#book-now-question").value.trim().length <= 0) {
      all_valid = false;
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> Please provide a question.
                    </div>`;
    }

    if(this.querySelector("#book-now-question-type").value == "multichoice" &&
      this.querySelector("#book-now-question-answers").value.trim().length <= 0) {
      all_valid = false;
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> Multi-choice questions require answers.
                    </div>`;
    }

    this.querySelector('.errors-container').innerHTML = errors;

    return all_valid
  }

  async moveUp() {
    if(!await confirmPlus(`Are you sure you want to change the order of this question?`)) {
      return
    }
    let temp_data = {
      question: this.querySelector('#book-now-question').value,
      type:this.querySelector('#book-now-question-type').value,
      answers: this.querySelector('#book-now-question-answers').value
    }

    this.previousElementSibling.before(this);

    this.querySelector('#book-now-question').value = temp_data.question;
    this.querySelector('#book-now-question-type').value = temp_data.type;
    this.querySelector('#book-now-question-answers').value = temp_data.answers;
  }

  async moveDown() {
    if(!await confirmPlus(`Are you sure you want to change the order of this question?`)) {
      return
    }
    let temp_data = {
      question: this.querySelector('#book-now-question').value,
      type:this.querySelector('#book-now-question-type').value,
      answers: this.querySelector('#book-now-question-answers').value
    }

    this.nextElementSibling.after(this);

    this.querySelector('#book-now-question').value = temp_data.question;
    this.querySelector('#book-now-question-type').value = temp_data.type;
    this.querySelector('#book-now-question-answers').value = temp_data.answers;
  }
}

customElements.define('book-now-question', BookNowQuestion)

class BookNowBusinessUnitsSelect extends HTMLSelectElement {
  constructor() {
    super();
    this.template = document.createElement('template');
  }

  // NOT TESTED
  requestUpdate(data){
    this.data = data;

    this.data.sort((a, b) => a.name.localeCompare(b.name));

    let options = this.data.map(business_unit => `<option value="${business_unit.id}">${business_unit.name}</option>`).join("")
    this.template.innerHTML =`
      <option value=null>Choose</option>
      ${options}
    `
    
    Array.from(this.options).map(opt=> {
        opt.parentNode.removeChild(opt);
    });

    this.appendChild(this.template.content.cloneNode(true));
    this.value = this.getAttribute("data-selected");
    if(this.selectedOptions.length == 0) {
      this.value = "null"
    }
  }

  async connectedCallback() {
    this.data_binder = new DataBinder(`/admin/domains/${this.getAttribute("domain_id")}/service_titan_business_units`, true);
    this.data_binder.register(this);
    if(this.data_binder.data) {
      this.requestUpdate(this.data_binder.data);
    }
  }

  disconnectedCallback(){
    this.data_binder.unregister(this);
  }
}

customElements.define('book-now-business-units-select', BookNowBusinessUnitsSelect, {extends: 'select'});

class BookNowJobTypesSelect extends HTMLSelectElement {
  constructor() {
    super();
    this.template = document.createElement('template');
  }

  requestUpdate(data){
    this.data = data;

    let filtered_data = this.data.filter((job_type) => job_type.businessUnitIds.includes(parseInt(this.getAttribute("business_unit_id")))  )
    
    filtered_data.sort((a, b) => a.name.localeCompare(b.name));

    let options = filtered_data.map(job_type => `<option value="${job_type.id}">${job_type.name} (${job_type.duration / 60 / 60}hrs)</option>`).join("")
    this.template.innerHTML =`
    <option value=null>Choose</option>
    ${options}
    `
    
    Array.from(this.options).map(opt=> {
        opt.parentNode.removeChild(opt);
    });

    this.appendChild(this.template.content.cloneNode(true));
    
    this.value = this.getAttribute("data-selected");
    if(this.selectedOptions.length == 0) {
      this.value = "null"
    }
  }

  async connectedCallback() {
    this.data_binder = new DataBinder(`/admin/domains/${this.getAttribute("domain_id")}/service_titan_job_types`, true);
    this.data_binder.register(this);
    if(this.data_binder.data) this.requestUpdate(this.data_binder.data);
  }

  getJobLength() {
    let duration = this.data.find((job_type) => job_type.id.toString() === this.value).duration;
    return duration;
  }

  setBusinessUnit(business_unit_id) {
    this.setAttribute("business_unit_id", business_unit_id)
    this.requestUpdate(this.data)
  }

  disconnectedCallback(){
    this.data_binder.unregister(this);
  }
}

customElements.define('book-now-job-types-select', BookNowJobTypesSelect, {extends: 'select'});